import axios from 'axios';

import { API_URL } from '../config/api';

export interface ContactData {
    name: string;
    email: string;
    phone?: string;
    message: string;
}

export const contactService = {
    sendContactMessage: async (data: ContactData): Promise<{ success: boolean; message: string }> => {
        const response = await axios.post(`${API_URL}/contact`, data);
        return response.data;
    },
    sendConsultationRequest: async (data: any): Promise<{ success: boolean; message: string; id?: string }> => {
        const response = await axios.post(`${API_URL}/consultation`, data);
        return response.data;
    },
};
